import React, { Component } from "react";
import { withRouter } from "react-router-dom";
// import { connect } from "react-redux";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  TextInput,
  Tip,
  Spinner,
  Layer
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
//import {withRouter} from 'react-router';
import auth from "./Components/Security/Auth";
//import Toast from 'grommet/components/Toast'
import { showToast } from "./common/UtilityHelper";
import {
  callApiPostJson,
  callApiText,
  injectStyle,
  release,
  logAccess,
  callApiGetJson,
  APIServerURL,
  callApiValidatePort,
  envKey,
} from "./Components/GlobalSettings";
import hpeBgImg from "./assets/hpe-bg.jpg";
import CustomerRegistration from "./Components/CustomerRegistration";
import LoginCustomerForgotPasswd from "./Components/LoginCustomerForgotPasswd";
import FirstTimeUser from "./Components/FirstTimeUser";
// import { setTaxonomyDataRequest } from "./actions/TaxonomyActions";

class LoginCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "Initial data...",
      navbarFlag: false,
      userMessage: undefined,
      hasAllRegistrationData: true,
      showEmployeePartnerLoginPage: false,
      showCustomerLoginPage: false,
      showLoginSelectionPage: true,
      showPasswordResetPage: false,
      showHPEPassportRegistrationPage: false,
      email: undefined, //anbd
      pass: undefined,
      disableLoginButton: true,
      hpeUIDDisable: release === "ITG" || release === "PRO" ? false : true,
      resetPasswordErrorText: undefined,
      newCustomerRegister: {
        UserID: null,
        EmailAddress: null,
        FirstName: null,
        LastName: null,
        Password: null,
        ConfirmPassword: null,
        UserType: "3",
        showCustRegistrationPage: false,
        showCustForgotPwdPage: false,
      },
      isRequiredPortOpen: true,
      isOldIE: false,
      IEPopup: false,
      userRegistrationMessage: undefined,
      isRegSuccess: false,
      showHPEPassportRegistrationLoader: false,
      PwdResetMessage: undefined,
      isPwdResetSuccess: false,
      showPwdResetLoader: false
    };

    this._HPEOnBackClick = this._HPEOnBackClick.bind(this);
    this._HPERegisterClick = this._HPERegisterClick.bind(this);
    this._HPEForgotPasswordClick = this._HPEForgotPasswordClick.bind(this);
    this._handleCustomerLoginSubmit = this._handleCustomerLoginSubmit.bind(
      this
    );
    this._HideCustReg = this._HideCustReg.bind(this);
    this._HideCustForgotPwd = this._HideCustForgotPwd.bind(this);
    this.hasAllRegistrationData = this.hasAllRegistrationData.bind(this);
    this._registerCustomer = this._registerCustomer.bind(this);
    this._handleCustPwdReset = this._handleCustPwdReset.bind(this);
  }

  componentDidMount() {}
  _HPEOnBackClick() {
    //this.props.history.goBack();
    //this.props.hide()
    this.props.history.push("/login");
  }

  _registerCustomer(newCustomerRegisterVM){

    console.log("callBack Reg hit with parm as ", newCustomerRegisterVM);
    if(newCustomerRegisterVM && newCustomerRegisterVM.EmailAddress && newCustomerRegisterVM.FirstName &&
      newCustomerRegisterVM.LastName && newCustomerRegisterVM.Password )
  {
    this.setState({showHPEPassportRegistrationLoader: true, showCustRegistrationPage: false});
      console.log('Submit registration page starting');
      var endpoint =  '/Account/HPECustomerCreateNew';
      //var postData = { "Password": this.state.resetPassword1, "Guid": this.props.location.query.resetpassword };
      let token = "n/a";

      callApiPostJson(endpoint, newCustomerRegisterVM, token).then(data =>{
          console.log('HPEPassportRegisterResponse data:');
          console.log(data);
          if(data && data.Subscribed_DemoPortal){
              this.setState({
                 // email: data.EmailAddress,
                  showHPEPassportRegistrationLoader: false,
                 // showLoadingPage: false,
                  userRegistrationMessage: data.RegistrationMessage,
                  isRegSuccess: true
              });
              showToast({
                message: data.RegistrationMessage,
                intent: "success",
              });
          }
          else if(data)
              this.setState({isRegSuccess: false, userRegistrationMessage: data.RegistrationMessage, showHPEPassportRegistrationLoader: false});
              showToast({
                message: data.RegistrationMessage,
                intent: "danger",
              });
      });
  }
  }

  _HideCustReg() {
    this.setState({ showCustRegistrationPage: false, showLoadingPage: false });
  }

  _HideCustForgotPwd() {
    this.setState({ showCustForgotPwdPage: false, showLoadingPage: false });
  }

  _HPERegisterClick() {
    this.setState({ showCustRegistrationPage: true });
    //this.props.history.push("/customerregistartion");
  }
  _HPEForgotPasswordClick() {
    this.setState({ showCustForgotPwdPage: true });
    //this.props.history.push("/logincustomerforgotpasswd");
  }

  handlePasswordChange = (e) => {
    this.setState({ pass: e.target.value });
  };

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };

  hasAllRegistrationData() {
    //Verifies user profile data.
    var UserInfo = auth.getUserInfo();
    console.log("Verify user has Registration info :", UserInfo);
    if (
      !UserInfo ||
      !UserInfo.TimeZone ||
      !UserInfo.UserLocation ||
      !UserInfo.UserLocation.Country ||
      !UserInfo.Job ||
      !UserInfo.UserExpertise ||
      !UserInfo.UserExpertise.ExpertLevelName
    )
      return false;

    console.log("Verify user has Registration info returning TRUE");
    console.log(UserInfo);
    return true;
  }

  _handleCustPwdReset(passwordResetVM)
  {
    console.log('_handleForgotPasswordPageSubmit starting...', passwordResetVM);
    if(passwordResetVM.PassportEmailID)
    {
      this.setState({showPwdResetLoader: true});
        console.log('Submit password reset starting');
        var endpoint =  '/Account/HPECustForgetPwd';
        let token = "n/a";

        callApiPostJson(endpoint, passwordResetVM, token).then(data =>{
            console.log('HPECustForgetPwd data:');
            console.log(data);
            if(data && !data.Message){//data.Message means an userMessage occured
                this.setState({
                    isPwdResetSuccess: true,
                    showPwdResetLoader: false,                    
                    PwdResetMessage: data.ResetPassportSrvMessage
                });
                showToast({
                  message: data.ResetPassportSrvMessage,
                  intent: "success",
                });
            }else{
                console.log("data.Message:", data.Message);
                this.setState({
                  isPwdResetSuccess: false,
                  showPwdResetLoader: false,                    
                  PwdResetMessage: data.Message[0]
              });
              showToast({
                message: data.ResetPassportSrvMessage,
                intent: "danger",
              });
                //this.setState({userMessage: <Toast status='critical'> {data.Message[0]} </Toast>, showLoadingPage: false, showHPEPassportForgotPasswordPage: false});
            }
        });

        this.setState({showLoadingPage: true});
    }
  }

  _handleCustomerLoginSubmit(e) {
    e.preventDefault();
    this.setState({ disableLoginButton: true, userMessage: undefined });
    const email = this.state.email;
    const pass = this.state.pass;
    var type = this.state.showCustomerLoginPage ? "customer" : "other";
    console.log(
      "submitCustomerLogin fired!" + email + " : " + pass + " : " + type
    );
    // this.props.history.push('/home');
    // console.log('going to Home');

    if (this.state.hpeUIDDisable && this.state.showEmployeePartnerLoginPage) {
      //this means we're faking HPEUID for development AND user clicked on HPE Employee login
      this.setState({ showLoadingPage: true });
      auth.login(email, pass, (isAuth) => {
        if (isAuth) {
          logAccess(null, null, "Successful Login", "login", auth.getToken());
          console.log(
            "_handleCustomerLoginSubmit.login - Logged In: " + isAuth
          );
          const { location } = this.props;
          console.log("location:", location);
          if (!this.hasAllRegistrationData()) {
            this.props.router.replace("/registration");
            console.log("going to registration");
          } else {
            /* else if (location.state && location.state.nextPathname) {
            this.props.router.replace(location.state.nextPathname);
            console.log(
              "going to previous location:",
              location.state.nextPathname
            ); */
            // this.props.history.push("/home");
            console.log("**Till now its fine and Props is ", this.props);
            this.props.router.replace("/home");
            console.log("going to /");
          }
        } else {
          this.setState({
            userMessage: (
              <Tip status="critical"> Error logging in. Please retry. </Tip>
            ),
            disableLoginButton: false,
          });
        }
      });
    } else {
      //do regular customer login - HPE Passport
      if (!email || !pass) {
        if (!pass) {
          showToast({
            message: "Password is required.",
            intent: "danger",
          });
        }
        if (!email) {
          showToast({
            message: "Username is required.",
            intent: "danger",
          });
        }
        return;
      }
      this.setState({ showLoadingPage: true });
      auth.loginHPEPassport(email, pass, (isAuth) => {
        if (isAuth) {
          logAccess(null, null, "Successful Login", "login", auth.getToken());
          console.log(
            "_handleCustomerLoginSubmit.login - Logged In: " + isAuth
          );
          const { location } = this.props;
          console.log("location:", location);
          if (!this.hasAllRegistrationData()) {
            console.log("Registration data missing");
            this.setState({ hasAllRegistrationData: false });
            //this.props.router.replace('/registration');
            /*               else if (location.state && location.state.nextPathname) {
                      this.props.router.replace(location.state.nextPathname)
                  } else if(queryString.parse(this.props.location.search).ReturnUrl !== undefined){
                      this.props.router.replace(queryString.parse(this.props.location.search).ReturnUrl); */
          } else {
            // After 0365 login , redirect to previous path,
            /*                   if (window.localStorage.hasOwnProperty('previousPath')) {
                          let previousPath = window.localStorage.getItem("previousPath");
                          this.props.router.replace(previousPath);
                          window.localStorage.removeItem('previousPath');
                      } else { //  no previous path
                          this.props.router.replace('/')
                      } */
            console.log("**This is time to route to Home**");
            this.props.history.push("/home");
          }
        } else {
          this.setState({
            userMessage: (
              <Tip status="critical"> Error logging in. Please retry. </Tip>
            ),
            disableLoginButton: false,
            showLoadingPage: false,
          });
          showToast({
            message: "Invalid username or password.",
            intent: "danger",
          });
        }
      });
    }
  }

  render() {
    var bshowcustomerRegPage = this.state.showCustRegistrationPage;
    var bshowcustForgotPwdPage = this.state.showCustForgotPwdPage;

    const { showLoadingPage } = this.state;

    var bRegReq = this.state.hasAllRegistrationData ? false : true;
    var UserInformation = auth.getUserInfo() ? auth.getUserInfo() : undefined;

    var regspinnerContent = "";
    if(this.state.showHPEPassportRegistrationLoader){
      regspinnerContent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="large" />
            <Text size="large">Registration in Progress...</Text>
          </Box>
        </Layer>
      );
    }
    
    
    var resetspinnerContent = "";
    if (this.state.showPwdResetLoader) {
      resetspinnerContent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="large" />
            <Text size="large">Reset in Progress...</Text>
          </Box>
        </Layer>
      );
    }

    return (
      <Box fill="vertical" align="stretch" justify="start">
        {bshowcustomerRegPage && (
          <CustomerRegistration hide={this._HideCustReg} registerCallback={this._registerCustomer}/>
        )}
        {bshowcustForgotPwdPage && (
          <LoginCustomerForgotPasswd hide={this._HideCustForgotPwd} resetReqCallBack = {this._handleCustPwdReset} />
        )}
        {!bshowcustomerRegPage && !bshowcustForgotPwdPage && (
          <Main
            overflow="auto"
            background={{
              image: `url(${hpeBgImg})`,
              color: "background",
              dark: true,
            }}
            flex
            align="center"
            justify="center"
          >
            <Box
              align="center"
              justify="center"
              background={{ color: "background", dark: false }}
              pad="medium"
              round="xsmall"
              gap="medium"
            >
              <Heading level="1" size="small" margin="none">
                HPE Demonstration Portal
              </Heading>
              <Paragraph margin="none">
                Welcome to the HPE Demo Portal! Please login using your existing
                HPE Passport credentials. If you do not have a HPE Passport
                account, please click the 'Register' link below.
              </Paragraph>
              {bRegReq && UserInformation ? <FirstTimeUser Uinfo={UserInformation} /> : ""}
              <Box align="center" justify="center" gap="small">
                <TextInput
                  placeholder="Username (email)"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleEmailChange}
                />
                <TextInput
                  placeholder="Password"
                  name="pass"
                  type="password"
                  value={this.state.pass}
                  onChange={this.handlePasswordChange}
                />
              </Box>
              <Box align="center" justify="center" gap="medium" direction="row">
                <Button
                  label="Back"
                  primary={false}
                  secondary
                  onClick={this.props.hide}
                />
                <Button
                  // label="HPE Customer Login"
                  label={
                    showLoadingPage ? (
                      <Box
                        direction="row"
                        gap="small"
                        justify="center"
                        align="center"
                      >
                        <Spinner size="small" color="brand" />{" "}
                        <Text>HPE Customer Login</Text>
                      </Box>
                    ) : (
                      "HPE Customer Login"
                    )
                  }
                  secondary
                  type="submit"
                  onClick={this._handleCustomerLoginSubmit}
                />
              </Box>
              {regspinnerContent}
              {resetspinnerContent}
              <Box align="center" justify="center">
                <Anchor label="Register" onClick={this._HPERegisterClick} />
                <Anchor
                  label="Forgot Password?"
                  onClick={this._HPEForgotPasswordClick}
                />
              </Box>
              <Paragraph>
                For the best user experience, we recommend Chrome
              </Paragraph>
            </Box>
          </Main>
        )}
      </Box>
    );
  }
}

/* const mapStateToProps = function (state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTaxonomyData: (data) => {
      dispatch(setTaxonomyDataRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginCustomer); */

export default withRouter(LoginCustomer);
